/* Predictive search - externalized + deferred 2026-08-19 (was a 15KB inline <script> in
   header.liquid). Liquid-free, interaction-only, so defer runs it after parse without blocking
   render. Cached across all pages.

   Rewired 2026-08-29: binds the live toolbar bars (.cpg-tb__input desktop, .cpg-tb-m__input
   mobile). The previous build bound .cp-ref-search__input / #cpDesktopSearchResults, which the
   header redesign left hidden and orphaned, so typing produced nothing on either desktop or
   mobile. The classifier, renderer and window.cpgSearch contract are unchanged. */
(function () {
  var MINIMUM_QUERY_LENGTH = 2;
  var DEBOUNCE = 180;

  /* API base. Overridable from Liquid (window.CPG_SEARCH_API_BASE) so the deployed URL is not
     welded into a cached asset; falls back to the current Cloud Run URL when nothing is injected. */
  var CPG_SEARCH_API =
    window.CPG_SEARCH_API_BASE ||
    "https://carpartglobal-api-2wqerijrtq-uc.a.run.app";

  function getSearchUrl(query) {
    var searchPath =
      window.routes && window.routes.search_url
        ? window.routes.search_url
        : "/search";
    return searchPath + "?type=product&q=" + encodeURIComponent(query);
  }

  function cpgEsc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  /* Prices come from OUR api in the shop's base currency (USD). Shopify only converts money it
     renders itself, so once a market is switched to a local currency the cart would show CAD while
     this dropdown showed a raw USD number under a "$" sign - visually identical, ~35% apart. Convert
     the same way the theme money filter does. Today this is a no-op: with localCurrencies off, rate
     is 1.0 and code is USD, so the untouched "$" + 2dp path runs. */
  function cpgMoney(v) {
    if (v == null || v === "") return "";
    var n = Number(v);
    if (isNaN(n)) return "";
    var c = (window.Shopify && window.Shopify.currency) || {};
    var rate = parseFloat(c.rate || "1") || 1;
    var code = c.active || "USD";
    if (rate === 1 && code === "USD") return "$" + n.toFixed(2);
    try {
      return new Intl.NumberFormat(undefined, { style: "currency", currency: code }).format(n * rate);
    } catch (e) {
      return "$" + (n * rate).toFixed(2);
    }
  }

  /* Shop All's ACTUAL query-string contract, read from its readUrl()/vehicle() - not guessed:
       brands= (comma list) NOT vendor=; cat= (main category) NOT main=; sub=; q=; and
       make= AND model= together (year optional) - make alone or model alone is IGNORED.
     Emitting the wrong names silently lands the shopper on an unfiltered Shop All. */
  function cpgShopAll(f, q) {
    var p = [];
    if (f.vendor) p.push("brands=" + encodeURIComponent(f.vendor));
    if (f.main) p.push("cat=" + encodeURIComponent(f.main));
    if (f.sub) p.push("sub=" + encodeURIComponent(f.sub));
    var v = f.vehicle;
    if (v && v.make && v.model) {
      if (v.year) p.push("year=" + v.year);
      p.push("make=" + encodeURIComponent(v.make));
      p.push("model=" + encodeURIComponent(v.model));
    }
    if (f.q) p.push("q=" + encodeURIComponent(f.q));
    if (!p.length && q) p.push("q=" + encodeURIComponent(q));
    return "/pages/shop-all?" + p.join("&");
  }

  /* Bold every query term where it appears in a label (match-anywhere), like the reference UIs.
     Escapes each slice, so it is safe to drop the returned HTML straight into innerHTML. */
  function cpgHi(text, query) {
    var t = String(text == null ? "" : text);
    var terms = String(query || "").toLowerCase().split(/\s+/).filter(function (x) { return x.length >= 2; });
    if (!terms.length) return cpgEsc(t);
    var esc = terms.map(function (s) { return s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); });
    var re = new RegExp("(" + esc.join("|") + ")", "ig");
    var out = "", last = 0, m;
    while ((m = re.exec(t))) {
      out += cpgEsc(t.slice(last, m.index)) + "<strong>" + cpgEsc(m[0]) + "</strong>";
      last = m.index + m[0].length;
      if (m.index === re.lastIndex) re.lastIndex++;
    }
    return out + cpgEsc(t.slice(last));
  }

  /* One suggestion row (make / model / brand / category / brand-line). No image slot - these are
     entities, not products, so the empty placeholder box is dropped. titleHtml is already-escaped
     HTML (from cpgHi); tag is plain text. */
  function cpgRow(href, titleHtml, tag) {
    return '<a class="cp-header__search-result-item cpg-sb-row--noimg" href="' + href + '">' +
      "<span><span class=\"cp-header__search-result-title\">" + titleHtml + "</span>" +
      '<span class="cp-header__search-result-price">' + cpgEsc(tag) + "</span></span></a>";
  }

  /* Groups are ordered by INTENT, most decisive first. A part number resolves the whole query, so
     it leads; keyword products are the fallback and come last. PURE - it renders, it does not
     remember. The caller reads d.jump itself, so each panel keeps its OWN last-jump. */
  function cpgRenderResolved(d, query) {
    var jump = d && d.jump ? d.jump : null;
    var g = (d && d.groups) || {};
    var html = "";

    if (d && d.note) {
      html += '<span class="cp-header__search-result-message">' + cpgEsc(d.note) + "</span>";
    }

    if (jump) {
      html += '<div class="cp-header__search-result-list">';
      html += '<a class="cp-header__search-result-item" href="/products/' + cpgEsc(jump.handle) + '">';
      html += (jump.image
        ? '<img class="cp-header__search-result-image" src="' + cpgEsc(jump.image) + '" alt="" loading="lazy">'
        : "") + '<span>';
      html += '<span class="cp-header__search-result-title">' + cpgEsc(jump.title) + "</span>";
      html += '<span class="cp-header__search-result-price">' +
              cpgEsc(jump.sku || "") + " &middot; Go to part &rarr;</span>";
      html += "</span></a></div>";
    }

    var pn = (g.part_number || []).filter(function (p) { return !jump || p.handle !== jump.handle; });
    var lists = [];
    if (pn.length) lists.push(["Part numbers", pn.slice(0, 4)]);

    /* Vehicles: the precise resolved one (may carry a year) leads, then make->models expansion and
       model-code / numeric-fragment matches. Deduped by make+model. */
    var vlist = [];
    if (g.vehicle && g.vehicle.make && g.vehicle.model) vlist.push(g.vehicle);
    (g.vehicles || []).forEach(function (v) {
      var k = (v.make + "|" + v.model).toLowerCase();
      if (!vlist.some(function (x) { return (x.make + "|" + x.model).toLowerCase() === k; })) vlist.push(v);
    });
    vlist.slice(0, 8).forEach(function (v) {
      var label = [v.year, v.make, v.model].filter(Boolean).join(" ");
      var href, tag;
      if (v.year && v.make && v.model) {
        /* complete vehicle -> straight to the fitted results */
        href = cpgShopAll({ vehicle: v }, query); tag = "Vehicle";
      } else if (v.make && v.model) {
        /* make+model only -> the Shop by Vehicle year stepper ("what year is your X?"), which lands
           on fitted results. Never a year-less Shop All (that showed a half-selected vehicle). */
        href = "/pages/manufacturers?make=" + encodeURIComponent(v.make) + "&model=" + encodeURIComponent(v.model);
        tag = "Vehicle · pick your year";
      } else {
        href = cpgShopAll({ vehicle: v }, query); tag = "Vehicle";
      }
      html += cpgRow(href, cpgHi(label, query), tag);
    });

    (g.brands || []).slice(0, 5).forEach(function (b) {
      /* A brand with its own collection page goes THERE; brands without one keep the Shop All
         fallback, so this can only upgrade a link, never break one. */
      var href = b.handle ? "/collections/" + cpgEsc(b.handle) : cpgShopAll({ vendor: b.name }, query);
      html += cpgRow(href, cpgHi(b.name, query), b.handle ? "Brand · shop the brand →" : "Brand");
    });

    /* Brand lines: a matched brand paired with the categories it stocks (powerstop -> Brake Rotors). */
    (g.brand_lines || []).slice(0, 5).forEach(function (l) {
      html += cpgRow(cpgShopAll({ vendor: l.brand, main: l.main, sub: l.sub }, query),
                     cpgHi(l.brand + " " + l.term, query), "Brand line");
    });

    /* 2026-10-03 (owner): "Category" rows are ONLY our own category pages (g.collections, from the
       curated category list), each opening its /collections page. Supplier part-type names
       ("Thermal Protection Hose Sleeve") are not our categories: they show as search suggestions
       and open the search page. Older API without g.collections: fall back to the previous rows. */
    if (g.collections) {
      g.collections.slice(0, 5).forEach(function (c) {
        html += cpgRow("/collections/" + cpgEsc(c.handle), cpgHi(c.name, query),
                       "Category · " + Number(c.count).toLocaleString("en-US") + " parts");
      });
      (g.categories || []).filter(function (c) { return c.level === "product_type"; }).slice(0, 3).forEach(function (c) {
        html += cpgRow(getSearchUrl(c.term), cpgHi(c.term, query), "Search");
      });
    } else {
      (g.categories || []).slice(0, 6).forEach(function (c) {
        var f = c.level === "product_type" ? { q: c.term } : { main: c.main, sub: c.sub };
        html += cpgRow(cpgShopAll(f, query), cpgHi(c.term, query), "Category");
      });
    }

    lists.forEach(function (pair) {
      html += '<div class="cp-header__search-result-list">';
      pair[1].forEach(function (p) {
        html += '<a class="cp-header__search-result-item cpg-sb-row--noimg" href="/products/' + cpgEsc(p.handle) + '"><span>' +
                '<span class="cp-header__search-result-title">' + cpgEsc(p.title) + "</span>" +
                '<span class="cp-header__search-result-price">' + cpgEsc(p.sku || "") + "</span></span></a>";
      });
      html += "</div>";
    });

    var prods = g.products || [];
    if (prods.length) {
      html += '<div class="cp-header__search-result-list">';
      prods.slice(0, 5).forEach(function (p) {
        html += '<a class="cp-header__search-result-item" href="/products/' + cpgEsc(p.handle) + '">';
        html += p.image
          ? '<img class="cp-header__search-result-image" src="' + cpgEsc(p.image) + '" alt="" loading="lazy">'
          : "";
        html += '<span><span class="cp-header__search-result-title">' + cpgHi(p.title, query) + "</span>";
        var m = cpgMoney(p.price);
        if (m) html += '<span class="cp-header__search-result-price">' + m + "</span>";
        html += "</span></a>";
      });
      html += "</div>";
    }

    if (!html) {
      html = '<span class="cp-header__search-result-message">Nothing matched. Try a part number or a brand.</span>';
    }
    /* The catch-all footer. A MAKE (or make+model) query is a vehicle intent, not a keyword: sending
       "toyota" to the text-search page just returns a flat 700+ keyword grab-bag with no way to
       narrow. So route it to the Shop-by-Vehicle stepper instead, matching the vehicle rows above:
         make+model+year -> fitted Shop All
         make+model      -> year stepper (/pages/manufacturers?make&model)
         make            -> make stepper (/pages/manufacturers?make) -> pick model, then year
       Everything else (brands, categories, keywords) still falls through to the /search page. */
    var gv = g.vehicle;
    var seeAllHref, seeAllLabel;
    if (gv && gv.make && gv.model && gv.year) {
      seeAllHref = cpgShopAll({ vehicle: gv }, query);
      seeAllLabel = "See all parts for " + cpgEsc([gv.year, gv.make, gv.model].join(" "));
    } else if (gv && gv.make && gv.model) {
      seeAllHref = "/pages/manufacturers?make=" + encodeURIComponent(gv.make) + "&model=" + encodeURIComponent(gv.model);
      seeAllLabel = "Pick your year for " + cpgEsc(gv.make + " " + gv.model) + " &rarr;";
    } else if (gv && gv.make) {
      seeAllHref = "/pages/manufacturers?make=" + encodeURIComponent(gv.make);
      seeAllLabel = "Shop " + cpgEsc(gv.make) + " by vehicle &rarr;";
    } else {
      seeAllHref = getSearchUrl(query);
      seeAllLabel = "See all results for &ldquo;" + cpgEsc(query) + "&rdquo;";
    }
    html += '<a class="cp-header__search-view-all" href="' + cpgEsc(seeAllHref) + '">' + seeAllLabel + "</a>";
    return html;
  }

  function cpgResolve(query, signal) {
    return fetch(CPG_SEARCH_API + "/storefront/search/resolve", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ q: query }),
      signal: signal
    }).then(function (r) {
      if (!r.ok) throw new Error("search failed");
      return r.json();
    });
  }

  /* Published for the mobile overlay (its own IIFE, cannot see this closure) and any future
     consumer. Shared rather than duplicated so panels cannot drift: one classifier call, one
     renderer. render() is pure and each caller keeps its own jump. */
  window.cpgSearch = { resolve: cpgResolve, render: cpgRenderResolved };

  /* Self-contained panel styling, injected once. Scoped under .cpg-sb-panel so it does not depend
     on whatever header CSS still styles the .cp-header__search-* item classes. */
  function injectCss() {
    if (document.getElementById("cpg-sb-css")) return;
    var s = document.createElement("style");
    s.id = "cpg-sb-css";
    s.textContent =
      ".cpg-tb__search,.cpg-tb-m__search{position:relative;}" +
      ".cpg-sb-panel{position:absolute;top:calc(100% + 6px);left:0;right:0;z-index:10000;" +
      "background:#fff;border:1px solid #e2e5ea;border-radius:10px;" +
      "box-shadow:0 14px 38px rgba(15,18,24,.16);max-height:min(72vh,560px);overflow-y:auto;" +
      "padding:6px;display:none;text-align:left;}" +
      ".cpg-sb-panel.is-open{display:block;}" +
      ".cpg-sb-panel .cp-header__search-result-message{display:block;padding:8px 12px;font-size:12px;color:#6b7280;}" +
      ".cpg-sb-panel .cp-header__search-result-list{display:block;}" +
      ".cpg-sb-panel .cp-header__search-result-item{display:flex;align-items:center;gap:10px;" +
      "padding:8px 10px;border-radius:8px;text-decoration:none;color:#14161b;}" +
      ".cpg-sb-panel .cp-header__search-result-item:hover,.cpg-sb-panel .cp-header__search-result-item.is-active{background:#f4f5f7;}" +
      ".cpg-sb-panel .cp-header__search-result-image{width:40px;height:40px;flex:0 0 40px;" +
      "border-radius:6px;background:#f0f1f3;object-fit:contain;}" +
      ".cpg-sb-panel .cp-header__search-result-item>span{min-width:0;}" +
      ".cpg-sb-panel .cp-header__search-result-title{display:block;font-size:14px;font-weight:500;" +
      "line-height:1.25;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}" +
      ".cpg-sb-panel .cp-header__search-result-title strong{font-weight:800;color:#0b0d11;}" +
      ".cpg-sb-panel .cp-header__search-result-price{display:block;font-size:12px;color:#6b7280;margin-top:1px;}" +
      ".cpg-sb-panel .cp-header__search-view-all{display:block;padding:10px 12px;margin-top:4px;" +
      "border-top:1px solid #eef0f3;font-size:13px;font-weight:600;color:#be151b;text-decoration:none;}" +
      ".cpg-sb-panel .cp-header__search-view-all:hover{text-decoration:underline;}";
    document.head.appendChild(s);
  }

  /* Bind one toolbar input: inject a results panel into its form, wire input/focus/keyboard, and
     handle Enter -> exact-part jump. Each call closes over its OWN jump so desktop and mobile
     panels never send Enter to each other's part. */
  function attach(input) {
    if (!input || input.dataset.cpgSbBound === "true") return;
    input.dataset.cpgSbBound = "true";

    var form = input.closest("form") || input.parentElement;
    form.style.position = "relative";

    var panel = form.querySelector(".cpg-sb-panel");
    if (!panel) {
      panel = document.createElement("div");
      panel.className = "cpg-sb-panel";
      panel.setAttribute("role", "listbox");
      form.appendChild(panel);
    }

    var jump = null;
    var timer = null;
    var ctrl = null;
    var activeIdx = -1;

    function rows() {
      return [].slice.call(
        panel.querySelectorAll(".cp-header__search-result-item, .cp-header__search-view-all")
      );
    }
    function open() { panel.classList.add("is-open"); }
    function close() { panel.classList.remove("is-open"); activeIdx = -1; }
    function setActive(i) {
      var r = rows();
      r.forEach(function (e) { e.classList.remove("is-active"); });
      if (i >= 0 && i < r.length) {
        r[i].classList.add("is-active");
        if (r[i].scrollIntoView) r[i].scrollIntoView({ block: "nearest" });
        activeIdx = i;
      } else {
        activeIdx = -1;
      }
    }

    input.addEventListener("input", function () {
      var q = this.value.trim();
      clearTimeout(timer);
      if (ctrl) { ctrl.abort(); ctrl = null; }
      /* The jump belongs to the query that produced it, so it dies the moment the query changes. */
      jump = null;
      activeIdx = -1;

      if (q.length < MINIMUM_QUERY_LENGTH) {
        panel.innerHTML = "";
        close();
        return;
      }

      /* Something clickable on the first keystroke, rendered synchronously with zero network, so the
         panel is never a dead "Searching..." the shopper cannot act on during the debounce/fetch. */
      panel.innerHTML =
        '<a class="cp-header__search-view-all" href="' + cpgEsc(getSearchUrl(q)) + '">' +
        "Search for &ldquo;" + cpgEsc(q) + "&rdquo;</a>" +
        '<span class="cp-header__search-result-message">Searching...</span>';
      open();

      timer = setTimeout(function () {
        ctrl = new AbortController();
        cpgResolve(q, ctrl.signal)
          .then(function (data) {
            jump = data && data.jump ? data.jump : null;
            panel.innerHTML = cpgRenderResolved(data, q);
            open();
          })
          .catch(function (error) {
            if (error && error.name === "AbortError") return;
            panel.innerHTML =
              '<a class="cp-header__search-view-all" href="' + cpgEsc(getSearchUrl(q)) + '">' +
              "Search for &ldquo;" + cpgEsc(q) + "&rdquo;</a>";
            open();
          });
      }, DEBOUNCE);
    });

    input.addEventListener("focus", function () {
      if (panel.innerHTML.trim() !== "") open();
    });

    input.addEventListener("keydown", function (e) {
      if (e.key === "ArrowDown") {
        e.preventDefault();
        var r = rows();
        if (r.length) setActive(Math.min((activeIdx < 0 ? -1 : activeIdx) + 1, r.length - 1));
      } else if (e.key === "ArrowUp") {
        e.preventDefault();
        setActive(activeIdx - 1);
      } else if (e.key === "Enter") {
        var r = rows();
        if (activeIdx >= 0 && r[activeIdx]) {
          e.preventDefault();
          window.location.href = r[activeIdx].getAttribute("href");
        }
        /* else: fall through to the form submit handler (jump or native /search). */
      } else if (e.key === "Escape") {
        close();
      }
    });

    /* Enter with no highlighted row: an exact part-number match jumps straight to that part;
       anything else falls through to the form's native submit -> /search (page kept separate). */
    form.addEventListener("submit", function (e) {
      if (jump && jump.handle) {
        e.preventDefault();
        window.location.href = "/products/" + jump.handle;
      }
    });

    document.addEventListener("click", function (ev) {
      if (!form.contains(ev.target)) close();
    });
  }

  function init() {
    injectCss();
    [".cpg-tb__input", ".cpg-tb-m__input"].forEach(function (sel) {
      [].slice.call(document.querySelectorAll(sel)).forEach(attach);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
  document.addEventListener("shopify:section:load", init);
})();
